import * as UI from "@iyk/ui"
import { appConfig } from "../../../app-config.ts"
import { Sheet } from "./sheet.tsx"

export const CdCard = () => {
  return (
    <Sheet.Root>
      <Sheet.Trigger className="relative flex items-center justify-between border border-grayA-3 bg-grayA-2 rounded p-3 overflow-hidden">
        <span className="text-xs-departure text-left">
          Tap your CD to access the <br /> Star Line digital download
        </span>
        <img
          src={`${appConfig.s3.assets.appUrl}/shopify-shop/star_line_album_cd.png`}
          alt="Tap to learn more"
          className="object-cover rounded-sm size-10"
        />
      </Sheet.Trigger>
      <Sheet.Content title="Tap your CD" description="Tap your CD to access the Star Line digital download">
        <div className="relative">
          <div className="flex flex-col gap-6 px-4 py-8">
            <p className="text-sm-departure text-center">How to tap </p>
            <video
              src={`${appConfig.s3.assets.appUrl}/ctr-howtotap.mp4`}
              className="size-full aspect-video"
              preload="metadata"
              playsInline
              controls
              autoPlay
            />
            <Sheet.Close asChild>
              <UI.Button type="button" kind="solid" size="md" className="w-full">
                Close
              </UI.Button>
            </Sheet.Close>
          </div>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}
